/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import React from 'react';
import { UnstyledButton, Icon, FeedbackIdeaIcon } from '@/shared/ui';

interface FeedbackTriggerProps {
  onClick: () => void;
  label: string;
}

/**
 * Always-visible header action that opens the suggestion / bug report popup.
 *
 * Soft tinted pill: a subtle brand-tinted background with a gentle hover lift,
 * carrying the composed "share an idea" icon (chat bubble + lightning bolt).
 */
export const FeedbackTrigger: React.FC<FeedbackTriggerProps> = ({ onClick, label }) => (
  <UnstyledButton
    data-testid="feedback-trigger-button"
 className="group inline-flex items-center justify-center w-[32px] h-[32px] max-md:w-[32px] max-md:h-[32px] shrink-0 cursor-pointer rounded-full border border-transparent p-0 bg-(--seed-base)/8 text-(--seed-base) transition-[background-color,color,box-shadow,transform] duration-150 ease-out hover:bg-(--seed-base)/15 hover:shadow-[0_2px_10px_-2px_rgb(var(--seed-rgb)/0.45)] hover:-translate-y-px active:translate-y-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-(--seed-base)/40 :bg-(--brand-accent)/22 :ring-(--brand-accent)/45"
    onClick={onClick}
    aria-label={label}
    title={label}
  >
    <Icon
      as={FeedbackIdeaIcon}
      size="md"
      className="transition-transform duration-150 ease-out group-hover:scale-110"
    />
  </UnstyledButton>
);
